(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  const footerMobile = window.matchMedia('(max-width: 520px)');
  const floatingContact = document.querySelector('[data-floating-contact]');
  const footerDisclosures = document.querySelectorAll('.footer-disclosure');
  if (footerMobile.matches) footerDisclosures.forEach((disclosure) => disclosure.removeAttribute('open'));
  if (floatingContact && floatingContact.dataset.ready !== 'true') {
    floatingContact.dataset.ready = 'true';
    const floatingToggle = floatingContact.querySelector('[data-floating-contact-toggle]');
    const floatingActions = floatingContact.querySelector('[data-floating-contact-actions]');
    const setFloatingOpen = (open) => {
      floatingContact.classList.toggle('is-open', open);
      floatingToggle.setAttribute('aria-expanded', String(open));
      floatingActions.setAttribute('aria-hidden', String(!open));
      floatingActions.inert = !open;
    };
    floatingToggle.addEventListener('click', () => setFloatingOpen(!floatingContact.classList.contains('is-open')));
    document.addEventListener('click', (event) => {
      if (!floatingContact.contains(event.target)) setFloatingOpen(false);
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartDrawerContent = cartDrawer?.querySelector('[data-cart-drawer-content]');
  const cartEndpoint = cartDrawer?.dataset.cartUrl || '/cart.js';
  const cartChangeEndpoint = cartDrawer?.dataset.cartChangeUrl || '/cart/change.js';
  const cartEmptyLabel = cartDrawer?.dataset.cartEmpty || 'Your bag is empty.';
  const cartLoadingLabel = cartDrawer?.dataset.cartLoading || 'Loading your bag…';
  const cartSubtotalLabel = cartDrawer?.dataset.cartSubtotal || 'Subtotal';
  const cartDrawerActions = cartDrawer?.querySelector('[data-cart-drawer-actions]');
  let cartDrawerOpener;
  const isCartPage = window.location.pathname === '/cart';
  if (isCartPage && cartDrawer) {
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.style.setProperty('display', 'none', 'important');
  }

  const escapeCartHtml = (value) => String(value ?? '').replace(/[&<>"']/g, (character) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[character]);
    const formatCartMoney = (cents) => {
    const formatted = window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(cents)
      : `Tk ${(Number(cents || 0) / 100).toFixed(0)}`;
    return formatted.replace(/\.00(?=\D|$)/g, '');
  };
  const updateHeaderBagCount = (cart) => {
    const bag = document.querySelector('.header-bag');
    if (!bag) return;
    let count = bag.querySelector('.header-bag__count');
    if (cart?.item_count > 0) {
      if (!count) {
        count = document.createElement('span');
        count.className = 'header-bag__count';
        count.setAttribute('aria-hidden', 'true');
        bag.append(count);
      }
      count.textContent = cart.item_count;
    } else if (count) {
      count.remove();
    }
    const label = bag.querySelector('.visually-hidden');
    if (label) label.textContent = `Bag (${cart?.item_count || 0})`;
  };
  const closeCartDrawer = () => {
    if (!cartDrawer || cartDrawer.getAttribute('aria-hidden') === 'true') return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartDrawer.style.display = 'none';
    document.body.classList.remove('cart-drawer-open');
    cartDrawerOpener?.focus();
  };
  const renderCartDrawer = (cart) => {
    if (!cartDrawerContent) return;
    if (!cart?.items?.length) {
      cartDrawerContent.innerHTML = `<p class="cart-drawer__empty">${cartEmptyLabel}</p>`;
      if (cartDrawerActions) cartDrawerActions.hidden = true;
      return;
    }
    cartDrawerContent.innerHTML = `
      <div class="cart-drawer__items">
        ${cart.items.map((item) => {
          const image = item.image ? `<img src="${escapeCartHtml(item.image)}" alt="${escapeCartHtml(item.product_title)}" loading="lazy">` : '';
          const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-drawer__variant">${escapeCartHtml(item.variant_title)}</p>` : '';
          const originalLine = Number(item.original_line_price || 0);
          const finalLine = Number(item.final_line_price || 0);
          const isFree = finalLine === 0 && originalLine > 0;
            const linePrice = isFree || originalLine > finalLine ? `<s>${formatCartMoney(originalLine)}</s> <strong>${isFree ? 'Free' : formatCartMoney(finalLine)}</strong>`
            : `${formatCartMoney(item.final_price)} each`;
          return `<article class="cart-drawer__item">
            <a class="cart-drawer__item-image" href="${escapeCartHtml(item.url)}">${image}</a>
            <div class="cart-drawer__item-details">
              <h3><a href="${escapeCartHtml(item.url)}">${escapeCartHtml(item.product_title)}</a></h3>
              ${variant}
              <div class="cart-drawer__item-bottom">
                <p class="cart-drawer__item-meta">${linePrice}</p>
                <div class="cart-drawer__quantity" data-cart-line-key="${escapeCartHtml(item.key)}" aria-label="Quantity">
                  <button type="button" data-cart-quantity-decrease aria-label="Decrease quantity">−</button>
                  <span data-cart-quantity-value>${escapeCartHtml(item.quantity)}</span>
                  <button type="button" data-cart-quantity-increase aria-label="Increase quantity">+</button>
                </div>
              </div>
            </div>
            <strong>${isFree ? 'Free' : formatCartMoney(finalLine)}</strong>
          </article>`;
        }).join('')}
      </div>
      <div class="cart-drawer__subtotal">
        <div><span>${cartSubtotalLabel}</span>${cart.original_total_price > cart.total_price ? `<s class="cart-drawer__original-total">${formatCartMoney(cart.original_total_price)}</s>` : ''}</div>
        <strong>${formatCartMoney(cart.total_price)}</strong>
      </div>
      ${cart.total_discount > 0 ? `<p class="cart-drawer__discount">${cart.items.some((item) => Number(item.final_line_price || 0) === 0 && Number(item.original_line_price || 0) > 0) ? 'Keychain offer applied' : Math.round((cart.total_discount / cart.original_total_price) * 100) + '% off applied'} · You save ${formatCartMoney(cart.total_discount)}</p>` : ''}
      <p class="cart-drawer__delivery-note">Free delivery over Tk 1,000. Delivery within 5 days.</p>
    `;
    if (cartDrawerActions) cartDrawerActions.hidden = false;
  };
  const refreshCartDrawer = async ({ showLoading = false } = {}) => {
    if (!cartDrawerContent) return;
    const hasRenderedContent = Boolean(cartDrawerContent.querySelector('.cart-drawer__items, .cart-drawer__empty'));
    if (showLoading && !hasRenderedContent) {
      cartDrawerContent.innerHTML = `<p class="cart-drawer__loading">{{ 'cart.drawer_loading' | t }}</p>`;
    }
    cartDrawerContent.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch(cartEndpoint, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Cart unavailable');
      renderCartDrawer(await response.json());
    } catch (error) {
      if (!cartDrawerContent.querySelector('.cart-drawer__items, .cart-drawer__empty')) {
        cartDrawerContent.innerHTML = `<p class="cart-drawer__empty">${cartEmptyLabel}</p>`;
      }
    } finally {
      cartDrawerContent.removeAttribute('aria-busy');
    }
  };
  const updateCartLine = async (lineKey, quantity, controls) => {
    if (!lineKey || !cartDrawer) return;
    controls?.forEach((control) => { control.disabled = true; });
    try {
      const response = await fetch(cartChangeEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity })
      });
      if (!response.ok) throw new Error('Cart update unavailable');
      const cart = await response.json();
      renderCartDrawer(cart);
      updateHeaderBagCount(cart);
    } catch (error) {
      void refreshCartDrawer({ showLoading: false });
    }
  };
  cartDrawer?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-quantity-decrease], [data-cart-quantity-increase]');
    if (!button) return;
    const control = button.closest('[data-cart-line-key]');
    const value = control?.querySelector('[data-cart-quantity-value]');
    const current = Number(value?.textContent || 1);
    const quantity = button.hasAttribute('data-cart-quantity-increase') ? current + 1 : Math.max(0, current - 1);
    updateCartLine(control?.dataset.cartLineKey, quantity, control?.querySelectorAll('button'));
  });
  const openCartDrawer = async (button) => {
    if (isCartPage || !cartDrawer) return;
    cartDrawerOpener = button;
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartDrawer.style.display = 'block';
    document.body.classList.add('cart-drawer-open');
    cartDrawer.querySelector('.cart-drawer__panel')?.focus();
    window.reeeTrack?.('reee_cart_entry', { source: 'header' });
    await refreshCartDrawer();
  };
  if (!isCartPage) {
    document.querySelectorAll('[data-cart-drawer-open]').forEach((button) => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        openCartDrawer(button);
      });
    });
  }
  cartDrawer?.querySelectorAll('[data-cart-drawer-close]').forEach((button) => button.addEventListener('click', closeCartDrawer));
  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeCartDrawer(); });
  window.addEventListener('reee:cart-updated', () => { if (cartDrawer?.getAttribute('aria-hidden') === 'false') refreshCartDrawer(); });
  if (window.location.pathname === '/cart') {
    window.reeeTrack?.('reee_cart_view', { source: 'page' });
  }
  const searchDialog = document.querySelector('[data-search-dialog]');
  const searchForm = searchDialog?.querySelector('form');
  const searchInput = searchDialog?.querySelector('[data-search-input]');
  const searchResults = searchDialog?.querySelector('[data-search-results]');
  let searchTimer;
  let searchRequest;
  let searchOpener;

  const closeSearch = () => {
    if (!searchDialog?.open) return;
    searchDialog.close();
  };

  document.querySelectorAll('[data-search-open]').forEach((button) => {
    button.addEventListener('click', () => {
      searchOpener = button;
      document.querySelector('.mobile-menu[open]')?.removeAttribute('open');
      searchDialog?.showModal();
      window.reeeTrack?.('reee_search_open', { source: 'header' });
      requestAnimationFrame(() => searchInput?.focus());
    });
  });

  searchForm?.addEventListener('submit', () => {
    const query = searchInput?.value.trim();
    if (query) window.reeeTrack?.('reee_search_submit', { query });
  });

  searchDialog?.querySelector('[data-search-close]')?.addEventListener('click', closeSearch);
  searchDialog?.addEventListener('click', (event) => {
    if (event.target === searchDialog) closeSearch();
  });
  searchDialog?.addEventListener('close', () => searchOpener?.focus());

  searchInput?.addEventListener('input', () => {
    window.clearTimeout(searchTimer);
    searchRequest?.abort();
    const term = searchInput.value.trim();
    searchInput.setAttribute('aria-expanded', term.length >= 2 ? 'true' : 'false');
    if (term.length < 2) {
      searchResults.innerHTML = `<p>${searchResults.dataset.hint || ''}</p>`;
      return;
    }

    searchTimer = window.setTimeout(async () => {
      searchRequest = new AbortController();
      const url = `${searchForm.dataset.predictiveUrl}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=hide&section_id=predictive-search`;
      try {
        const response = await fetch(url, { signal: searchRequest.signal });
        if (!response.ok) throw new Error('Search unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const section = html.querySelector('#shopify-section-predictive-search');
        if (section) searchResults.innerHTML = section.innerHTML;
      } catch (error) {
        if (error.name !== 'AbortError') searchForm.submit();
      }
    }, 180);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const cartPageForm = document.querySelector('[data-cart-page-form]');
    const formatCartPageMoney = (cents) => {
    const formatted = window.Shopify?.formatMoney
      ? window.Shopify.formatMoney(cents)
      : `Tk ${(Number(cents || 0) / 100).toFixed(0)}`;
    return formatted.replace(/\.00(?=\D|$)/g, '');
  };
  const syncCartPage = (cart) => {
    const items = cart?.items || [];
    cartPageForm?.querySelectorAll('[data-cart-line]').forEach((control) => {
      const row = control.closest('.cart-item');
      const item = items.find((entry) => entry.key === control.dataset.cartLine);
      if (!item) {
        row?.remove();
        return;
      }
      const input = control.querySelector('[data-cart-page-quantity]');
      if (input) input.value = item.quantity;
      const total = row?.querySelector('.cart-item__total');
      if (total) total.textContent = formatCartPageMoney(item.final_line_price);
    });
    const total = cartPageForm?.querySelector('.cart-summary__total strong');
    if (total) total.textContent = formatCartPageMoney(cart?.total_price);
    const original = cartPageForm?.querySelector('.cart-summary__prices s');
    if (original) {
      if (Number(cart?.original_total_price || 0) > Number(cart?.total_price || 0)) {
        original.textContent = formatCartPageMoney(cart.original_total_price);
      } else {
        original.remove();
      }
    }
    const savings = cartPageForm?.querySelector('.cart-summary__savings');
    if (savings) {
      savings.hidden = !(Number(cart?.total_discount || 0) > 0);
      if (!savings.hidden) savings.textContent = `You save ${formatCartPageMoney(cart.total_discount)}`;
    }
    if (!items.length) window.location.reload();
  };
  const updateCartPageLine = async (lineKey, input, quantity) => {
    if (!lineKey || !input) return;
    input.disabled = true;
    const row = input.closest('.cart-item');
    row?.setAttribute('aria-busy', 'true');
    try {
      const response = await fetch('{{ routes.cart_change_url }}.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: lineKey, quantity: Math.max(0, Number(quantity) || 0) })
      });
      if (!response.ok) throw new Error('Cart update unavailable');
      syncCartPage(await response.json());
    } catch (error) {
      input.value = input.defaultValue;
    } finally {
      input.disabled = false;
      row?.removeAttribute('aria-busy');
    }
  };
  cartPageForm?.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-page-decrease], [data-cart-page-increase]');
    if (!button) return;
    const control = button.closest('[data-cart-line]');
    const input = control?.querySelector('[data-cart-page-quantity]');
    const current = Number(input?.value || 1);
    const quantity = button.hasAttribute('data-cart-page-increase') ? current + 1 : Math.max(0, current - 1);
    if (input) input.value = quantity;
    updateCartPageLine(control?.dataset.cartLine, input, quantity);
  });
  cartPageForm?.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-page-quantity]');
    if (!input) return;
    const control = input.closest('[data-cart-line]');
    updateCartPageLine(control?.dataset.cartLine, input, input.value);
  });
  document.querySelectorAll('[data-checkout-start]').forEach((button) => {
    button.addEventListener('click', () => {
      window.reeeTrack?.('reee_checkout_start', { source: 'cart' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.querySelectorAll('[data-sort-form]').forEach((form) => {
    const select = form.querySelector('[data-sort-select]');
    if (form.dataset.reeeSortReady === 'true') return;
    if (select) select.addEventListener('change', () => form.requestSubmit());
    form.dataset.reeeSortReady = 'true';
  });

  const loadMore = document.querySelector('[data-load-more]');
  const collectionGrid = document.querySelector('[data-collection-grid]');
  const loadMoreStatus = document.querySelector('[data-load-more-status]');
  if (loadMore && collectionGrid && loadMore.dataset.reeeLoadMoreReady !== 'true') {
    let isLoading = false;
    loadMore.addEventListener('click', async (event) => {
      event.preventDefault();
      if (isLoading || !loadMore.href) return;
      isLoading = true;
      loadMore.setAttribute('aria-busy', 'true');
      loadMore.textContent = 'Loading…';
      if (loadMoreStatus) loadMoreStatus.textContent = '';
      try {
        const response = await fetch(loadMore.href, { headers: { Accept: 'text/html' } });
        if (!response.ok) throw new Error('Load more request failed');
        const html = await response.text();
        const nextDocument = new DOMParser().parseFromString(html, 'text/html');
        const nextGrid = nextDocument.querySelector('[data-collection-grid]');
        if (!nextGrid) throw new Error('Next collection page is missing its product grid');
        nextGrid.querySelectorAll('.product-card').forEach((card) => collectionGrid.append(card));
        const nextLoadMore = nextDocument.querySelector('[data-load-more]');
        if (nextLoadMore) {
          loadMore.href = nextLoadMore.href;
          loadMore.textContent = 'Load more designs';
        } else {
          loadMore.remove();
        }
        if (loadMoreStatus) loadMoreStatus.textContent = 'More designs loaded.';
      } catch (error) {
        loadMore.textContent = 'Load more designs';
        if (loadMoreStatus) loadMoreStatus.textContent = 'Couldn’t load more designs. Try again.';
      } finally {
        isLoading = false;
        loadMore.removeAttribute('aria-busy');
      }
    });
    loadMore.dataset.reeeLoadMoreReady = 'true';
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-customer-messages"]) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-customer-messages-page]').forEach((page) => {
      if (page.dataset.messagesReady === 'true') return;
      page.dataset.messagesReady = 'true';

      const list = page.querySelector('[data-customer-messages-list]');
      const cards = Array.from(list?.children || []);
      const more = page.querySelector('[data-customer-messages-more]');
      const step = 12;
      let visible = step;

      const render = () => {
        cards.forEach((card, index) => {
          card.hidden = index >= visible;
        });
        if (!more) return;
        if (visible >= cards.length) {
          more.hidden = true;
          return;
        }
        more.hidden = false;
        more.textContent = more.dataset.moreLabel || 'Show more';
      };

      more?.addEventListener('click', () => {
        visible = Math.min(visible + step, cards.length);
        render();
        if (visible < cards.length) more.focus();
      });

      render();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.querySelectorAll('.product-page').forEach((page) => {
    if (page.dataset.reeeViewTracked === 'true') return;
    page.dataset.reeeViewTracked = 'true';
    window.reeeTrack?.('reee_product_view', {
      product_handle: page.dataset.productHandle,
      product_id: page.dataset.productId
    });
  });
  document.querySelectorAll('.product-form').forEach((form) => {
    if (form.dataset.reeeVariantReady === 'true') return;
    const notification = document.querySelector('[data-cart-notification]');
    notification?.querySelector('[data-cart-notification-open]')?.addEventListener('click', () => {
      notification.hidden = true;
      document.querySelector('[data-cart-drawer-open]')?.click();
    });

    form.addEventListener('submit', async (event) => {
      if (!notification || form.dataset.cartAjaxReady === 'true') return;
      event.preventDefault();
      form.dataset.cartAjaxReady = 'true';
      const submitButton = form.querySelector('.product-form__submit');
      const originalLabel = submitButton?.textContent || '';
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Adding…';
      }
      try {
        const response = await fetch('{{ routes.cart_add_url }}.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Could not add to bag');
        const item = await response.json();
        window.reeeTrack?.('reee_add_to_bag', {
          product_handle: form.closest('.product-page')?.dataset.productHandle,
          variant_id: item.variant_id || form.querySelector('[name="id"]')?.value,
          quantity: Number(form.querySelector('[name="quantity"]')?.value || 1),
          source: 'product'
        });
        const detail = notification.querySelector('[data-cart-notification-details]');
        if (detail) detail.textContent = item.product_title || 'Your selected piece is ready in your bag.';
        const cartResponse = await fetch('{{ routes.cart_url }}.js', { headers: { Accept: 'application/json' } });
        if (cartResponse.ok) {
          const cart = await cartResponse.json();
          const bag = document.querySelector('.header-bag');
          if (bag) {
            let count = bag.querySelector('.header-bag__count');
            if (cart.item_count > 0) {
              if (!count) {
                count = document.createElement('span');
                count.className = 'header-bag__count';
                count.setAttribute('aria-hidden', 'true');
                bag.append(count);
              }
              count.textContent = cart.item_count;
            } else if (count) {
              count.remove();
            }
          }
        }
        window.dispatchEvent(new CustomEvent('reee:cart-updated'));
        notification.hidden = false;
        window.setTimeout(() => { notification.hidden = true; }, 6000);
      } catch (error) {
        form.submit();
        return;
      } finally {
        form.dataset.cartAjaxReady = 'false';
        if (submitButton) {
          submitButton.disabled = false;
          submitButton.textContent = originalLabel;
        }
      }
    });

    const select = form.querySelector('[data-variant-select]');
    const dataElement = form.querySelector('[data-variant-data]');
    if (!select || !dataElement) return;

    let variants = [];
    try {
      variants = JSON.parse(dataElement.textContent || '[]');
    } catch (error) {
      return;
    }

    const page = form.closest('.product-page');
    const price = page?.querySelector('[data-product-price]');
    const image = page?.querySelector('.product-gallery__item--primary img');
    const submit = form.querySelector('.product-form__submit');
    const soldOutLabel = select.dataset.soldOutLabel || 'Sold out';
    const sizeDetail = form.querySelector('[data-size-detail]');
    const buttons = [...form.querySelectorAll('[data-option-index][data-option-value]')];
    const state = {};
    const selected = variants.find((variant) => String(variant.id) === String(select.value)) || variants[0];

    const findVariant = () => {
      const matches = variants.filter((variant) => Object.entries(state).every(([index, value]) => variant.options[Number(index)] === value));
      return matches.find((variant) => variant.available) || matches[0];
    };

    const revealSelectedOption = (button, behavior = 'auto') => {
      const picker = button.closest('.variant-picker__grid');
      if (!picker || picker.scrollWidth <= picker.clientWidth) return;
      const pickerRect = picker.getBoundingClientRect();
      const buttonRect = button.getBoundingClientRect();
      const target = picker.scrollLeft + buttonRect.left - pickerRect.left - ((picker.clientWidth - buttonRect.width) / 2);
      picker.scrollTo({ left: Math.max(0, target), behavior });
    };

    const syncVariant = (variant, behavior = 'auto') => {
      if (!variant) return;
      select.value = variant.id;
      variant.options.forEach((value, index) => { state[index] = value; });
      if (sizeDetail) sizeDetail.textContent = variant.options[Number(sizeDetail.dataset.optionIndex)] || '';
      buttons.forEach((button) => {
        const index = Number(button.dataset.optionIndex);
        const isSelected = variant.options[index] === button.dataset.optionValue;
        button.setAttribute('aria-pressed', String(isSelected));
        if (isSelected) revealSelectedOption(button, behavior);
      });
      if (price) price.textContent = variant.price;
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? variant.buttonLabel : soldOutLabel;
      }
      if (image && variant.image) {
        image.removeAttribute('srcset');
        image.src = variant.image;
        image.alt = variant.imageAlt || image.alt;
      }
    };

    if (selected) syncVariant(selected);
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        state[button.dataset.optionIndex] = button.dataset.optionValue;
        const variant = findVariant();
        syncVariant(variant, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth');
        window.reeeTrack?.('reee_variant_select', {
          product_handle: page?.dataset.productHandle,
          variant_id: variant?.id,
          option_index: button.dataset.optionIndex,
          option_value: button.dataset.optionValue
        });
      });
    });
    select.addEventListener('change', () => {
      const variant = variants.find((variant) => String(variant.id) === String(select.value));
      syncVariant(variant);
      window.reeeTrack?.('reee_variant_select', {
        product_handle: page?.dataset.productHandle,
        variant_id: variant?.id,
        source: 'select'
      });
    });
    form.dataset.reeeVariantReady = 'true';
  });
  (() => {
    const initializeProductReviewCarousels = (root = document) => {
      const carousels = [];
      if (root.matches?.('[data-product-review-carousel]')) carousels.push(root);
      root.querySelectorAll?.('[data-product-review-carousel]').forEach((carousel) => {
        if (!carousels.includes(carousel)) carousels.push(carousel);
      });

      carousels.forEach((carousel) => {
        if (carousel.dataset.productReviewReady === 'true') return;

        const track = carousel.querySelector('[data-product-review-track]');
        const slides = Array.from(carousel.querySelectorAll('[data-product-review-slide]'));
        const counter = carousel.querySelector('[data-product-review-counter]');
        const previous = carousel.querySelector('[data-product-review-prev]');
        const next = carousel.querySelector('[data-product-review-next]');
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

        if (!track || slides.length === 0 || !counter || !previous || !next) return;

        carousel.dataset.productReviewReady = 'true';
        let index = 0;
        let timer;
        let touchStartX = 0;

        const goTo = (nextIndex) => {
          index = (nextIndex + slides.length) % slides.length;
          track.style.setProperty('--product-review-index', index);
          slides.forEach((slide, slideIndex) => slide.setAttribute('aria-hidden', String(slideIndex !== index)));
          counter.textContent = `${index + 1} / ${slides.length}`;
          counter.setAttribute('aria-label', `Review ${index + 1} of ${slides.length}`);
        };

        const stop = () => window.clearInterval(timer);
        const restart = () => {
          stop();
          if (!reducedMotion.matches && slides.length > 1) {
            timer = window.setInterval(() => goTo(index + 1), 6500);
          }
        };
        const movePrevious = () => { goTo(index - 1); restart(); };
        const moveNext = () => { goTo(index + 1); restart(); };

        previous.addEventListener('click', movePrevious);
        next.addEventListener('click', moveNext);
        carousel.addEventListener('touchstart', (event) => {
          touchStartX = event.touches[0]?.clientX ?? 0;
          stop();
        }, { passive: true });
        carousel.addEventListener('touchend', (event) => {
          const touchEndX = event.changedTouches[0]?.clientX ?? 0;
          const distance = touchEndX - touchStartX;
          if (Math.abs(distance) >= 40) {
            distance < 0 ? moveNext() : movePrevious();
          } else {
            restart();
          }
        }, { passive: true });
        carousel.addEventListener('mouseenter', stop);
        carousel.addEventListener('mouseleave', restart);
        carousel.addEventListener('focusin', stop);
        carousel.addEventListener('focusout', (event) => {
          if (!carousel.contains(event.relatedTarget)) restart();
        });
        reducedMotion.addEventListener?.('change', restart);
        goTo(0);
        restart();
      });
    };

    initializeProductReviewCarousels();
    document.addEventListener('shopify:section:load', (event) => initializeProductReviewCarousels(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
